<template>
    <Modal width="1016" v-model="show" :title="user.name + ' -- ' + title" @on-cancel="onCancel(false)">
        <div class="print-root" :style="{height: $common.content.height - 170 + 'px'}" v-if="show">
            <div class="d-block" ref="print-main" desc="记录表" v-if="type === 1">
                <chushai :data="data" :user="user" v-if="kind === 1"/>
                <fushai :data="data" :user="user" v-if="kind === 2"/>
                <zhenduan :data="data" :user="user" v-if="kind === 3"/>
            </div>
            <div class="d-block" ref="print-main" desc="转诊单" v-if="type === 2">
                <chushai_zhuanzhendan :data="data" :user="user" v-if="kind === 1"/>
                <fushai_zhuanzhendan :data="data" :user="user" v-if="kind === 2"/>
            </div>
        </div>
        <div slot="footer" class="align-center">
            <Button class="width-100" type="success" v-if="type === 1 && !data.edited" @click="onConfirm">保存</Button>
            <Button class="width-100" type="primary" @click="onPrint">打印</Button>
        </div>
    </Modal>
</template>

<script type="text/javascript">
    import fayudangan from './fayudangan'
    import jichuxinxi from './jichuxinxi'

    import chushai from './chushai'
    import fushai from './fushai'
    import zhenduan from './zhenduan'

    import chushai_zhuanzhendan from "./chushai_zhuanzhendan";
    import fushai_zhuanzhendan from "./fushai_zhuanzhendan";

    import PrintJS from 'print-js'

    export default {
        components: {
            fayudangan,
            jichuxinxi,
            chushai,
            chushai_zhuanzhendan,
            fushai,
            fushai_zhuanzhendan,
            zhenduan,
        },
        data() {
            return {
                show: false,
                data: {},
                user: {},
                type: '', // 1-记录表 2-转诊单
                kind: '', // 1-初筛记录表 2-复筛记录表 3-诊断记录表
                title: '',
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initPrints');
        },
        async created() {},
        async mounted() {
            await this.$bus.on('initPrints', async (show, data, type, kind) => {
                console.log('this.initPrints---------->', show, data, type, kind);
                if (!show) return;
                this.show = show;
                data.month = (data.month % 1 !== 0) ? Math.trunc(data.month) : data.month;
                this.data = data;
                this.user = await this.$common.getUser(data.testUserId);
                this.type = type;
                this.kind = kind;

                if (type === 0){
                    this.title = '发育档案';
                }

                // 记录表
                if (type === 1){
                    let title = '';
                    if (kind === 1){
                        this.title = data.taskName + ' -- ' + '初筛记录表';
                        title = '0～6岁儿童心理行为发育初筛记录表 ';
                        if (this.data.month <= 12){
                            title += '婴儿期（0～1岁）';
                        }
                        if (this.data.month > 12 && this.data.month <= 36){
                            title += '幼儿期（1～3岁）';
                        }
                        if (this.data.month > 36){
                            title += '学龄前期（4～6岁）';
                        }
                    }
                    if (kind === 2){
                        this.title = data.taskName + ' -- ' + '复筛记录表';
                        title = '0～6岁儿童心理行为发育复筛记录表';
                        // 病史询问
                        if (!data.medicalHistory.array || data.medicalHistory.array.length === 0){
                            data.medicalHistory.array = [0, 0, 0, 0, 0];
                        }
                    }
                    if (kind === 3){
                        this.title = data.taskName + ' -- ' + '诊断记录表';
                        title = '0～6岁儿童心理行为发育异常诊断记录表';
                    }
                    this.data.title = title;
                }

                // 转诊单
                if (type === 2){
                    if (kind === 1){
                        this.title = data.taskName + ' -- ' + '初筛转诊单';
                    }
                    if (kind === 2){
                        this.title = data.taskName + ' -- ' + '复筛转诊单';
                    }
                }

                await this.$store.commit("initPrintFormData", data);

                await this.$forceUpdate();
            });
        },
        methods: {
            async onCancel(data){
                this.show = false;
                this.data = {};
                this.user = {};
                this.type = '';
                this.kind = '';
                await this.$bus.emit('initPrintsSaveSuccess', data);
                await this.$store.commit("initPrintFormData", {}); // 清空打印数据缓存
            },

            async onConfirm() {
                debugger
                let data = this.$store.state.printFormData;
                    data.edited = 1; // 表示已编辑
                console.log('this.onConfirm---------->', data);

                let res = await this.$api.putHttp('task/scale/result', {
                    testRecordId: data.testRecordId, // 测评记录id
                    testResult: JSON.stringify(data), // 测评结果JSON字符串
                });
                if (res.data.code !== 0){
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.$Message.success('保存' + res.data.msg);
                await this.onCancel(true);
            },

            async onPrint(){
                let data = this.$store.state.printFormData;
                if (data.referralStatus === 1 && data.referral === ''){
                    return await this.$common.alertModel('warning', '上转接诊医疗机构名称不能为空');
                }
                return await PrintJS({
                    printable: this.$refs["print-main"],
                    type: 'html',
                    maxWidth: '1000',
                    honorColor: true, // 是否彩色打印
                    style: '@page{size: 210mm 297mm; margin: 0; padding: 0;} body{margin: 0; padding: 0;}',
                    scanStyles: true,
                    css: '', // 如 ../style.css
                    targetStyles: ['*'], // *代表应用所有样式，默认值为null，如果不设置，打印窗口则会忽略所有样式
                    font_size: '999', // 解决字体大小问题
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/index.vue